package com.karawek.core.auth.usecase

import com.karawek.core.auth.api.Authenticator
import com.karawek.core.auth.model.OtpChannel
import com.karawek.core.auth.model.OtpHandle
import me.tatarka.inject.annotations.Inject
import software.amazon.lastmile.kotlin.inject.anvil.AppScope
import software.amazon.lastmile.kotlin.inject.anvil.SingleIn

@Inject
@SingleIn(AppScope::class)
class InitiateOtpUseCase(
    private val authenticator: Authenticator,
) {
    suspend operator fun invoke(
        channel: OtpChannel,
        destination: String,
        loginOrCreate: Boolean = true,
    ): Result<OtpHandle> {
        return authenticator.initiateOtp(
            channel = channel,
            value = destination,
            loginOrCreate = loginOrCreate,
        )
    }
}
